module.exports = __webpack_public_path__ + "static/our-classes-6-3c746c149bdbf4598730bd230fb68a6c.jpg";